import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { CMSService } from 'src/app/services/cms.service';
import { ScrollControlService } from 'src/app/services/scroll-control.service';

declare var $;

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

    data;

    constructor(
        private cms: CMSService,

    ) {}

    // constructor(
    //     private router: Router,
    //     private scroll: ScrollControlService
    // ) { }

    async ngOnInit() {
        // this.router.events.subscribe((val) => {
        //     if (val instanceof NavigationEnd) {
        //         this.scroll.toTop();
        //     }
        // });

        this.data = await this.cms.getInfo();
    }

}
